<template>
  <img src="/navicon.png" @click="onClick()" />
</template>
<script>
export default {
  methods: {
    onClick () {
      location.href = "/"
    }
  }
}
</script>
